module.exports = __webpack_public_path__ + "img/close-btn.7a547f81.svg";